<template>
  <transition
    name="transition-expand-height"

    @enter="onEnter"
    @after-enter="onAfterEnter"
    @leave="onLeave"
  >
    <slot />
  </transition>
</template>

<style lang="scss">
  .transition-expand-height {

    &-enter-active {
      transition:
        height 200ms ease-in-out,
        opacity 200ms 200ms ease-in-out;
      overflow: hidden;
    }

    &-leave-active {
      transition:
        height 200ms 200ms ease-in-out,
        opacity 200ms ease-in-out;
      overflow: hidden;
    }

    &-enter,
    &-leave-to {
      height: 0;
      opacity: 0;
    }
  }
</style>

<script>
// Export
export default {
  name: 'transition-expand-height',

  // Methods
  methods: {
    onEnter(element) {
      const width = getComputedStyle(element).width;

      element.style.width = width;
      element.style.position = 'absolute';
      element.style.visibility = 'hidden';
      element.style.height = 'auto';

      const height = getComputedStyle(element).height;

      element.style.width = null;
      element.style.position = null;
      element.style.visibility = null;
      element.style.height = 0;

      // Force repaint to make sure the
      // animation is triggered correctly.
      getComputedStyle(element).height; // eslint-disable-line no-unused-expressions

      // Trigger the animation.
      // We use `setTimeout` because we need
      // to make sure the browser has finished
      // painting after setting the `height`
      // to `0` in the line above.
      setTimeout(() => {
        element.style.height = height;
      });
    },
    onAfterEnter(element) {
      element.style.height = 'auto';
    },
    onLeave(element) {
      const height = getComputedStyle(element).height;

      element.style.height = height;

      // Force repaint to make sure the
      // animation is triggered correctly.
      getComputedStyle(element).height; // eslint-disable-line no-unused-expressions

      setTimeout(() => {
        element.style.height = 0;
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// ExpandHeight.vue?627d0682